// Co-op shared-session bindings. Mirrors iOS CoopEndpoints + /coop/* and
// POST /clans/{id}/coop. Real-time state arrives over the chat WebSocket on the
// room "coop:<id>" (see chat-socket.ts onFrame).
import { api } from "./client";
import type { CoopAnswerResponse, CoopCompleteResponse, CoopSession } from "./community-types";

export function createCoop(clanId: string, shareId: string): Promise<CoopSession> {
  return api.post<CoopSession>(`/clans/${encodeURIComponent(clanId)}/coop`, { share_id: shareId });
}

export function getCoop(coopId: string): Promise<CoopSession> {
  return api.get<CoopSession>(`/coop/${encodeURIComponent(coopId)}`);
}

export function joinCoop(coopId: string): Promise<CoopSession> {
  return api.post<CoopSession>(`/coop/${encodeURIComponent(coopId)}/join`);
}

export function leaveCoop(coopId: string): Promise<CoopSession> {
  return api.post<CoopSession>(`/coop/${encodeURIComponent(coopId)}/leave`);
}

export function startCoop(coopId: string): Promise<CoopSession> {
  return api.post<CoopSession>(`/coop/${encodeURIComponent(coopId)}/start`);
}

export function answerCoop(
  coopId: string,
  input: { questionIndex: number; correct: boolean; responseTimeMs?: number },
): Promise<CoopAnswerResponse> {
  return api.post<CoopAnswerResponse>(`/coop/${encodeURIComponent(coopId)}/answer`, {
    question_index: input.questionIndex,
    correct: input.correct,
    response_time_ms: input.responseTimeMs,
  });
}

export function completeCoop(coopId: string): Promise<CoopCompleteResponse> {
  return api.post<CoopCompleteResponse>(`/coop/${encodeURIComponent(coopId)}/complete`);
}

export function coopRoomId(coopId: string): string {
  return `coop:${coopId}`;
}
